export function setIn<T = any>(target: T, path: PropertyKey[], value: any) {
  if (typeof target !== 'object' || target === null) return
  let current: any = target
  for (let i = 0; i < path.length; i++) {
    const key = path[i]
    if (!current) return
    if (i === path.length - 1) {
      current[key] = value
    } else {
      if (current[key] === undefined) {
        current[key] = isNaN(path[i + 1]) ? {} : []
      } else if (current[key] === null || typeof current[key] !== 'object')
        return
      current = current[key]
    }
  }
}
